import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { type ReactNode } from 'react';

/** Error recuperable y fail-closed al comprobar el rol de administración. */
export function AuthRoleErrorScreen(): ReactNode {
  return (
    <Center h="100vh" p="md" role="alert" data-agent-id="admin.auth.role-error">
      <Stack align="center" gap="sm" maw={440}>
        <Title order={3}>No se pudo comprobar tu acceso</Title>
        <Text c="dimmed" ta="center">
          Comprueba tu conexión y vuelve a intentarlo. No se ha mostrado ningún
          dato de administración.
        </Text>
        <Button onClick={() => window.location.reload()}>
          Reintentar
        </Button>
      </Stack>
    </Center>
  );
}
